export const ArrowCircleBrokenRight = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_1266_1747)">
        <path
          d="M2.78288 5.83342C4.22375 3.34258 6.91685 1.66675 10.0014 1.66675C14.6037 1.66675 18.3347 5.39771 18.3347 10.0001C18.3347 14.6025 14.6037 18.3334 10.0014 18.3334C6.91685 18.3334 4.22375 16.6576 2.78288 14.1667M10.0013 13.3334L13.3346 10.0001M13.3346 10.0001L10.0013 6.66675M13.3346 10.0001H1.66797"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1266_1747">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
